//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'UserQuickInfo',

    data(){ return {

    }},

    mounted(){

    },

    computed: {
        user(){ return this.$store.getters['auth/user'] },

        username(){ return this.user.username ? this.user.username : this.user.name },

        userImage(){ return this.user.avatar ? this.user.avatar : 'https://cdn.quasar.dev/img/boy-avatar.png' }


    },

    methods: {

    }

}
